import Store from "@/store";

export default {
    path: '/video-editor',
    name: 'Video-Editor',
    component: () => import('@/views/video_editor/index.vue'),
    meta: {
        title: 'Редактор видео',
        forVisitors: true
    },
    beforeEnter: (to, from, next) => {
        if(Store.getters['entry_video/entry'].length === 0) {
            next({name: 'Theme'})
        } else {
            next()
        }
    }
}